import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { link } from '../constants/appConstants';
import PublicRoutes from '../navigation/PublicRoutes';
import ProtectedRoutes from '../navigation/ProtectedRoutes';
import AuthLayout from '../components/layouts/AuthLayout';
import LoginPage from '../pages/auth/LoginPage';
import DashboardLayout from '../components/layouts/DashboardLayout';
import DashboardPage from '../pages/dashboard/DashboardPage';
import NotFound from '../pages/NotFound';

const ReportManagementPage = React.lazy(() => import('../pages/dashboard/ReportManagementPage'));
const ContactSupportPage = React.lazy(() => import('../pages/dashboard/ContactSupportPage'));
const SettingsPage = React.lazy(() => import('../pages/dashboard/SettingsPage'));
const ChangePasswordPage = React.lazy(() => import('../pages/dashboard/ChangePasswordPage'));
const CompanyDetailPage = React.lazy(() => import('../pages/dashboard/CompanyDetailPage'));
const UserDetailPage = React.lazy(() => import('../pages/dashboard/UserDetailPage'));
const CompanyManagementPage = React.lazy(() => import('../pages/dashboard/CompanyManagementPage'));
const BrandGroupManagementPage = React.lazy(
  () => import('../pages/dashboard/BrandGroupManagementPage')
);
const UnifiedUserManagementPage = React.lazy(
  () => import('../pages/dashboard/UnifiedUserManagementPage')
);
const UnifiedRolesPage = React.lazy(() => import('../pages/dashboard/UnifiedRolesPage'));
const UserManagementPage = React.lazy(() => import('../pages/dashboard/UserManagementPage'));

const ResetPasswordPage = React.lazy(() => import('../pages/auth/ResetPasswordPage'));
const OtpVerificationPage = React.lazy(() => import('../pages/auth/OtpVerificationPage'));

const ChatManagement = React.lazy(() => import('../pages/dashboard/ChatManagement'));
const SessionIntelligencePage = React.lazy(
  () => import('../pages/dashboard/SessionIntelligencePage')
);
const UserSessionsPage = React.lazy(() => import('../pages/dashboard/UserSessionsPage'));

const GroupDetail = React.lazy(() => import('../pages/dashboard/GroupDetail'));
const ChatDetail = React.lazy(() => import('../pages/dashboard/ChatDetail'));

const TicketsPage = React.lazy(() => import('../pages/livechat/TicketsPage'));
const SessionsPage = React.lazy(() => import('../pages/livechat/SessionsPage'));
const AuditLogsPage = React.lazy(() => import('../pages/livechat/AuditLogsPage'));
const ContactsPage = React.lazy(() => import('../pages/livechat/ContactsPage'));

const Navigation = () => {
  return (
    <BrowserRouter>
      <Routes>
        {/* PUBLIC ROUTES */}
        <Route element={<PublicRoutes />}>
          <Route element={<AuthLayout />}>
            <Route path={link.default} element={<LoginPage />} />
            <Route path={link.otpVerification} element={<OtpVerificationPage />} />
            <Route path={link.resetPassword} element={<ResetPasswordPage />} />
          </Route>
        </Route>

        {/* PROTECTED ROUTES */}
        <Route element={<ProtectedRoutes />}>
          <Route element={<DashboardLayout />}>
            <Route path={link.dashboard} element={<DashboardPage />} />
            <Route path={link.userManagement} element={<UserManagementPage />} />
            <Route path={link.reportManagement} element={<ReportManagementPage />} />
            <Route path={link.companyManagement} element={<CompanyManagementPage />} />
            <Route path={link.unifiedBrands} element={<BrandGroupManagementPage />} />
            <Route path={link.unifiedUsers} element={<UnifiedUserManagementPage />} />
            <Route path={`${link.userDetail}/:id`} element={<UserDetailPage />} />
            <Route path={`${link.companyDetail}/:id`} element={<CompanyDetailPage />} />
            <Route path={link.settings} element={<SettingsPage />} />
            <Route path={link.changePassword} element={<ChangePasswordPage />} />
            <Route path={link.contactSupport} element={<ContactSupportPage />} />
            <Route path={link.chatManagement} element={<ChatManagement />} />
            <Route path={link.sessionIntelligence} element={<SessionIntelligencePage />} />
            <Route path={`${link.userSessions}/:id`} element={<UserSessionsPage />} />
            <Route path={link.roles} element={<UnifiedRolesPage />} />
            <Route path={link.livechatTickets} element={<TicketsPage />} />
            <Route path={link.livechatSessions} element={<SessionsPage />} />
            <Route path={link.livechatAuditLogs} element={<AuditLogsPage />} />
            <Route path={link.livechatContacts} element={<ContactsPage />} />

            <Route path="/chat/:id" element={<ChatDetail />} />
            <Route path="/group/:id" element={<GroupDetail />} />
          </Route>
        </Route>

        {/* KEEP IT AT THE END */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  );
};

export default Navigation;
